import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { EmptyEventState } from "../../components/empty/emptyEventState";
import { Icon } from "../../components/icon/icon";
import { BgWrapper } from "../../components/wrapper/bgWrapper";
import { useGetEventsQuery } from "../../redux/features/event/event.api";
import { useAppSelector } from "../../redux/hooks";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { formatDate } from "../../utils/helpers";

export const EventArchivesSettings = () => {
  const { isSignedIn } = useAppSelector((state) => state.auth);

  const navigate = useNavigate();

  const { data: archivedEvents, isFetching: fetchingArchivedEvents } =
    useGetEventsQuery(
      { status: "archived", page: 1, limit: 5 },
      {
        skip: !isSignedIn,
      },
    );

  return (
    <>
      {!fetchingArchivedEvents &&
      [undefined, 0].includes(archivedEvents?.data?.totalCount) ? (
        <EmptyEventState eventStatus={"archived"} />
      ) : undefined}

      {fetchingArchivedEvents &&
        Array.from({ length: 4 }).map((_, index) => (
          <BgWrapper
            key={`skeletion-${index}`}
            className="flex items-center gap-3"
          >
            <Skeleton
              className="size-[56px] rounded-md"
              width={"56px"}
              height={"56px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />

            <Skeleton
              className="flex-1 rounded-md"
              width={"100px"}
              height={"20px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
            />
          </BgWrapper>
        ))}

      {!fetchingArchivedEvents &&
      ![undefined, 0].includes(archivedEvents?.data?.totalCount)
        ? archivedEvents?.data?.data.map((event, index) => (
            <BgWrapper
              key={`archived-event-${index}-${event._id}`}
              className="flex cursor-pointer items-center gap-3"
              onClick={() => {
                navigate(`/events/${event.slug}/details`);
              }}
            >
              <img
                className="block aspect-square size-[56px] rounded-sm object-cover"
                alt="event-poster"
                src={event.image.replace("http:", "https:")}
              />

              <div className="flex flex-1 flex-col gap-[2px]">
                <p className="font-bold">{event.name}</p>
                <p className="text-sm text-grey-500">
                  Archived on {formatDate(event.updatedAt)}
                </p>
              </div>

              <Icon
                svg="caret-down"
                width={20}
                height={20}
                className="-rotate-90 text-grey-600"
              />
            </BgWrapper>
          ))
        : undefined}

      <BgWrapper
        className="flex cursor-pointer items-center gap-1 font-bold text-blue-500"
        onClick={() => {}}
      >
        <Icon svg="show-eye" width={20} height={20} />
        Show all
      </BgWrapper>
    </>
  );
};
